(function () {

  const SECTION_SELECTOR = '[data-social-video-slider]';

  const initVideoControls = (section) => {
    if (!section) return;
    const videos = section.querySelectorAll('video');
    videos.forEach((video) => {
      const media = video.closest(
        '.social-video-slider__media'
      );
      if (!media) return;
      const playButton = media.querySelector(
        '.social-video-slider__play'
      );
      if (!playButton) return;
    
      if (video.dataset.videoEventsInitialized === 'true') {
        return;
      }
      video.dataset.videoEventsInitialized = 'true';
      const updateButton = () => {
        if (!video.paused) {
          playButton.classList.add('is-playing');
          playButton.setAttribute(
            'aria-label',
            'Pause video'
          );
          playButton.setAttribute(
            'aria-pressed',
            'true'
          );
        } else {
          playButton.classList.remove('is-playing');

          playButton.setAttribute(
            'aria-label',
            'Play video'
          );
          playButton.setAttribute(
            'aria-pressed',
            'false'
          );
        }
      };

      playButton.addEventListener('click', (event) => {

        event.preventDefault();
        event.stopPropagation();
        if (video.paused) {
          video.play().catch((error) => {
            console.log('Video play failed:', error);
          });
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('ended', updateButton);

    });
  };

  const initVideoAutoPause = (section) => {
    if (!section) return;
    const videos = section.querySelectorAll('video');
    videos.forEach((video) => {
      if (
        video.dataset.autoPauseInitialized === 'true'
      ) {
        return;
      }
      video.dataset.autoPauseInitialized = 'true';
      video.addEventListener('play', () => {
        videos.forEach((otherVideo) => {
          if (otherVideo !== video) {
            otherVideo.pause();
          }
        });
      });
    });
  };

  const initSlider = (section) => {
    if (!section) return;
    const swiperEl = section.querySelector(
      '.ugc-video-swiper'
    );
    if (!swiperEl) return;
    const wrapper = swiperEl.querySelector(
      '.swiper-wrapper'
    );
    if (!wrapper) return;
    const slides = wrapper.querySelectorAll(
      '.social-video-slider__slide'
    );
    if (!slides.length) return;
    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });

    if (swiperEl.swiper) {
      swiperEl.swiper.update();
      return;
    }

    const navigation = section.querySelector(
      '.social-video-slider__navigation'
    );

    const pagination = section.querySelector(
      '.social-video-slider__pagination'
    );

    const sliderSettings = {

      speed: 800,

      allowTouchMove: true,

      grabCursor: true,

      watchSlidesProgress: true,

      slidesPerView: 'auto',

      spaceBetween: '24px',

      navigation: navigation
        ? {
            nextEl: navigation.querySelector(
              '.swiper-button-next'
            ),

            prevEl: navigation.querySelector(
              '.swiper-button-prev'
            ),

            disabledClass: 'swiper-button-disabled'
          }
        : false,

      pagination: pagination
        ? {
            el: pagination,
            type: 'bullets',
            clickable: true
          }
        : false

    };


    new Swiper(
      swiperEl,
      sliderSettings
    );

  };

  const destroySlider = (section) => {
    if (!section) return;
    const swiperEl = section.querySelector(
      '.ugc-video-swiper'
    );
    if (!swiperEl?.swiper) return;

    swiperEl.swiper.destroy(
      true,
      true
    );


    swiperEl
      .querySelectorAll(
        '.social-video-slider__slide'
      )
      .forEach((slide) => {

        slide.classList.remove(
          'swiper-slide'
        );

        slide.removeAttribute(
          'style'
        );

      });

  };


  /* ==========================================
     RESIZE OBSERVER
  ========================================== */

  const initResponsiveSlider = (section) => {

    if (!section) return;

    const swiperEl = section.querySelector(
      '.ugc-video-swiper'
    );

    if (!swiperEl) return;


    /*
     * Disconnect old observer
     */

    if (section._ugcResizeObserver) {

      section._ugcResizeObserver.disconnect();

    }


    let resizeTimeout;


    const resizeObserver = new ResizeObserver(() => {

      clearTimeout(resizeTimeout);


      resizeTimeout = setTimeout(() => {

        if (!swiperEl.swiper) {

          initSlider(section);

        } else {

          swiperEl.swiper.update();

        }

      }, 100);

    });


    resizeObserver.observe(section);


    section._ugcResizeObserver =
      resizeObserver;


    /*
     * Initial slider
     */

    initSlider(section);

  };


  /* ==========================================
     MAIN INITIALIZATION
  ========================================== */

  const initUGCVideoSlider = (section) => {

    if (!section) return;

    if (!section.matches(SECTION_SELECTOR)) {
      return;
    }


    initVideoControls(section);

    initVideoAutoPause(section);

    initResponsiveSlider(section);

  };


  /* ==========================================
     INITIAL LOAD
  ========================================== */

  const init = () => {

    const sections =
      document.querySelectorAll(
        SECTION_SELECTOR
      );

    sections.forEach((section) => {
      initUGCVideoSlider(section);
    });

  };


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section = event.target;

      if (
        section &&
        section.matches(SECTION_SELECTOR)
      ) {

        initUGCVideoSlider(section);

      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      const section = event.target;

      if (
        section &&
        section.matches(SECTION_SELECTOR)
      ) {

        if (section._ugcResizeObserver) {

          section._ugcResizeObserver.disconnect();

        }

        destroySlider(section);

      }

    }
  );


})();